export default __webpack_public_path__ + "static/media/Josh9-578x867.76369204.jpg";